import {Component} from 'react'
// import {random} from 'nanoid'
import TabItem from '../TabItem'
import ImageItem from '../ImageItem'
import './index.css'

class MatchGame extends Component {
  state = {
    imgurl:
      'https://assets.ccbp.in/frontend/react-js/match-game/orange-img.png',
    activeId: 'FRUIT',
    score: 0,
    timer: 60,
    iswrong: false,
  }

  componentDidMount() {
    this.timerId = setInterval(this.click, 1000)
  }

  click = () => {
    const {timer} = this.state
    const newTime = timer - 1
    this.setState({timer: newTime})
  }

  onclickTab = tabId => {
    this.setState({activeId: tabId})
  }

  playAgain = () => {
    this.setState({activeId: 'FRUIT', score: 0, timer: 60, iswrong: false})
    this.timerId = setInterval(this.click, 1000)
  }

  onclickThumbnail = imageUrl => {
    const {imagesList} = this.props
    const {iswrong, timer, imgurl, score} = this.state
    const randomImgoOt =
      imagesList[Math.floor(Math.random() * imagesList.length)]

    let sr
    let tm
    let a
    if (imageUrl === imgurl) {
      sr = score + 1
      tm = timer
      a = iswrong
    } else {
      sr = score
      tm = timer
      a = true
      clearInterval(this.timerId)
    }

    this.setState({
      imgurl: randomImgoOt.imageUrl,
      score: sr,
      timer: tm,
      iswrong: a,
    })
  }

  render() {
    const {imagesList, tabsList} = this.props
    const {iswrong, imgurl, activeId, timer, score} = this.state
    const filteredData = imagesList.filter(each => each.category === activeId)
    let a
    if (timer === 0 || iswrong) {
      clearInterval(this.timerId)
      a = (
        <div className="bg-main-score-container">
          <div className="score-card-main-container">
            <div className="Scorecard-container">
              <img
                src="https://assets.ccbp.in/frontend/react-js/match-game-trophy.png"
                alt="trophy"
                className="trophy"
              />
              <p className="your-score-para">YOUR SCORE</p>
              <p className="score-para">{score}</p>
              <div className="play-again-container">
                <img
                  alt="reset"
                  className="logo-img1"
                  src="https://assets.ccbp.in/frontend/react-js/match-game-play-again-img.png"
                />
                <button
                  onClick={this.playAgain}
                  className="playagain-btn"
                  type="button"
                >
                  PLAY AGAIN
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      a = (
        <div className="main-ka-main-container1">
          <div className="main-ka-main-container">
            <div className="main-image-container">
              <img className="main-image" src={imgurl} alt="match" />
            </div>
            <ul className="tabslist-container">
              {tabsList.map(each => (
                <TabItem
                  clickFun={this.onclickTab}
                  key={each.tabId}
                  data={each}
                  isActive={activeId === each.tabId}
                />
              ))}
            </ul>
            <ul className="imagelist-container">
              {filteredData.map(each => (
                <ImageItem
                  fcn={this.onclickThumbnail}
                  key={each.id}
                  data={each}
                />
              ))}
            </ul>
          </div>
        </div>
      )
    }

    return (
      <div>
        <div className="nav-logo-container">
          <img
            className="logo-img"
            alt="website logo"
            src="https://assets.ccbp.in/frontend/react-js/match-game-website-logo.png"
          />
          <ul className="score-container">
            <li>
              <p className="nav-score">
                Score: <span>{score}</span>
              </p>
            </li>
            <li className="score-container">
              <img
                src="https://assets.ccbp.in/frontend/react-js/match-game-timer-img.png"
                className="logo-img1"
                alt="timer"
              />
              <p className="timer-para">{timer} sec</p>
            </li>
          </ul>
        </div>
        <div className="second-container">{a}</div>
      </div>
    )
  }
}

export default MatchGame
